import React, { useState, useEffect, useContext } from "react";
import { Box, Button, Typography, Grid, Avatar } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CreatorContext } from "../../context/CreatorContext";

import Product1 from "../../assets/showcases/ecommerce/product1.jpg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ProductRestaurant1 from "../../assets/showcases/restaurant/product1.JPG";
import fontIcons from "../../assets/font-glyphs/icons.json";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

const ShowcaseProductDetail = ({ sector, product, showProductOptions }) => {
	const { t } = useTranslation();
	const { creator } = useContext(CreatorContext);
	const [content, setContent] = useState(null);

	const Icon = React.memo(({ family, name, color, fontSize, ...props }) => (
		<span
			style={{
				fontSize: fontSize ? fontSize : 10,
				fontFamily:
					family === "FontAwesome5"
						? "'FontAwesome5', 'FontAwesome5_Regular', 'FontAwesome5Brands'"
						: family,
				color: color ? color : "#000000",
			}}
			{...props}
		>
			{String.fromCodePoint(fontIcons[family][name])}
		</span>
	));
	useEffect(() => {
		const loadContent = () => {
			switch (sector) {
				case "ecommerce":
					return {
						name: t("homeProducts.blueSweater"),
						description: t("productDetails.blueSweaterDesc"),
						price: "€18.99",
						image: Product1,
					};
				case "restaurant":
					return {
						name: t("menuItems.pepperoniPizza"),
						description: t("productDetails.pepperoniPizzaDesc"),
						price: "€8.00",
						image: ProductRestaurant1,
					};
				default:
					return null;
			}
		};

		setContent(loadContent());
	}, [sector, t]);
	return (
		<Box>
			{product?.value === "productDetail1" && content && (
				<Box sx={{}}>
					<img
						src={content.image}
						alt={content.name}
						style={{ width: "100%", height: "200px", objectFit: "cover" }}
					/>
					<Box
						sx={{
							padding: 1,
							paddingTop: 0,
							display: "flex",
							flexDirection: "column",
							justifyContent: "space-between",
							height: "180px",
						}}
					>
						<Box>
							<Box
								sx={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<Typography
									variant="body2"
									sx={{ fontSize: "10px", fontWeight: "bold" }}
								>
									{content.name}
								</Typography>
								<Icon
									family={creator.favoriteIconType}
									name={creator.favoriteIconName}
								/>
							</Box>
							<Typography variant="body1" sx={{ fontSize: "8px" }}>
								<span
									dangerouslySetInnerHTML={{
										__html: content.description.replace(/\n/g, "<br>"),
									}}
								/>
							</Typography>
							<Typography
								variant="h6"
								sx={{ fontWeight: "bold", mt: 1, fontSize: "8px" }}
							>
								{content.price}
							</Typography>
						</Box>
						{showProductOptions && (
							<Button
								variant="outline"
								fullWidth
								sx={{
									backgroundColor: "#ffffff",
									"&:hover": {
										backgroundColor: "#ffffff",
									},
									color: "#000000",
									fontSize: "7px",
									borderRadius:
										creator && creator.buttonRounded ? "24px" : "0px",
									fontWeight: "bold",
									textTransform: "inherit",
									height: "28px",
									padding: 0,
									border: "1px solid #aaaaaa",
									marginBottom: 1,
									marginTop: 1,
								}}
							>
								{t("productDetails.options")}
								<KeyboardArrowDownIcon sx={{ fontSize: 8, color: "#000000" }} />
							</Button>
						)}
						<Button
							variant="contained"
							fullWidth
							sx={{
								backgroundColor: creator ? creator.color : "#45A049",
								"&:hover": {
									backgroundColor: creator ? creator.color : "#45A049",
								},
								color:
									creator && creator.whiteTextButton ? "#ffffff" : "#000000",
								fontSize: "8px",
								borderRadius: creator && creator.buttonRounded ? "24px" : "0px",
								fontWeight: "bold",
								textTransform: "uppercase",
								height: "28px",
								width: "100%",
							}}
						>
							{t("productDetails.addToCart")}
						</Button>
					</Box>
				</Box>
			)}
			{product?.value === "productDetail2" && content && (
				<Box sx={{ position: "relative" }}>
					<img
						src={content.image}
						alt={content.name}
						style={{ width: "100%", height: "390px", objectFit: "cover" }}
					/>
					<Box
						sx={{
							padding: 1,
							paddingTop: 0,
							display: "flex",
							flexDirection: "column",
							justifyContent: "space-between",
							position: "absolute",
							bottom: 20,
							left: 0,
							right: 0,
						}}
					>
						<Box sx={{ marginBottom: 1 }}>
							<Box
								sx={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<Typography
									variant="body2"
									sx={{
										fontSize: "10px",
										fontWeight: "bold",
										color: "#ffffff",
									}}
								>
									{content.name}
								</Typography>
								<Icon
									family={creator.favoriteIconType}
									name={creator.favoriteIconName}
									color={"#ffffff"}
								/>
							</Box>
							<Typography
								variant="h6"
								sx={{
									fontWeight: "bold",
									fontSize: "8px",
									color: "#ffffff",
								}}
							>
								{content.price}
							</Typography>
						</Box>
						<Box sx={{ display: "flex", gap: 1 }}>
							{showProductOptions && (
								<Button
									variant="contained"
									fullWidth
									sx={{
										backgroundColor: "#ffffff",
										"&:hover": {
											backgroundColor: "#ffffff",
										},
										color: "#000000",
										fontSize: "7px",
										borderRadius:
											creator && creator.buttonRounded ? "24px" : "0px",
										fontWeight: "bold",
										textTransform: "inherit",
										height: "28px",
										width: "40%",
										padding: 0,
									}}
								>
									{t("productDetails.options")}
									<KeyboardArrowDownIcon
										sx={{ fontSize: 8, color: "#000000" }}
									/>
								</Button>
							)}
							<Button
								variant="contained"
								fullWidth
								sx={{
									backgroundColor: creator ? creator.color : "#45A049",
									"&:hover": {
										backgroundColor: creator ? creator.color : "#45A049",
									},
									color:
										creator && creator.whiteTextButton ? "#ffffff" : "#000000",
									fontSize: "7px",
									borderRadius:
										creator && creator.buttonRounded ? "24px" : "0px",
									fontWeight: "bold",
									textTransform: "uppercase",
									height: "28px",
									width: showProductOptions ? "60%" : "100%",
									padding: 0,
								}}
							>
								{t("productDetails.addToCart")}
							</Button>
						</Box>
					</Box>
				</Box>
			)}
			{product?.value === "productDetail3" && content && (
				<Box sx={{}}>
					<Box sx={{ position: "relative", width: "100%", height: "240px" }}>
						<img
							src={content.image}
							alt={content.name}
							style={{ width: "100%", height: "240px", objectFit: "cover" }}
						/>
						<Box sx={{ position: "absolute", top: 0, right: 4 }}>
							<Icon
								family={creator.favoriteIconType}
								name={creator.favoriteIconName}
								fontSize={"14px"}
							/>
						</Box>
						<Button
							variant="contained"
							fullWidth
							sx={{
								backgroundColor: creator ? creator.color : "#45A049",
								"&:hover": {
									backgroundColor: creator ? creator.color : "#45A049",
								},
								color:
									creator && creator.whiteTextButton ? "#ffffff" : "#000000",
								fontSize: "12px",
								fontWeight: "bold",
								textTransform: "uppercase",
								height: "36px",
								width: "36px",
								borderRadius: "30px",
								position: "absolute",
								bottom: -20,
								left: "40%",
								minWidth: "36px",
							}}
						>
							<Icon
								family={"MaterialCommunityIcons"}
								name={"cart-outline"}
								fontSize={"14px"}
								color={creator.whiteTextButton}
							/>
						</Button>
					</Box>
					<Box
						sx={{
							padding: 1,
							paddingTop: 0,
							display: "flex",
							flexDirection: "column",
							justifyContent: "space-between",
							mt: 1,
						}}
					>
						<Box>
							<Box
								sx={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<Typography
									variant="h6"
									sx={{ fontWeight: "bold", fontSize: "8px", mb: 2 }}
								>
									{content.price}
								</Typography>
							</Box>
							<Typography variant="body1" sx={{ fontSize: "8px" }}>
								<span
									dangerouslySetInnerHTML={{
										__html: content.description.replace(/\n/g, "<br>"),
									}}
								/>
							</Typography>
						</Box>
						<Box>
							{showProductOptions && (
								<Button
									variant="outline"
									fullWidth
									sx={{
										backgroundColor: "#ffffff",
										"&:hover": {
											backgroundColor: "#ffffff",
										},
										color: "#000000",
										fontSize: "7px",
										borderRadius:
											creator && creator.buttonRounded ? "24px" : "0px",
										fontWeight: "bold",
										textTransform: "inherit",
										height: "28px",
										padding: 0,
										border: "1px solid #aaaaaa",
										marginBottom: 1,
										marginTop: 1,
									}}
								>
									{t("productDetails.options")}
									<KeyboardArrowDownIcon
										sx={{ fontSize: 8, color: "#000000" }}
									/>
								</Button>
							)}
						</Box>
					</Box>
				</Box>
			)}
			{product?.value === "productDetail4" && content && (
				<Box sx={{}}>
					<Box sx={{ position: "relative", width: "100%", height: "200px" }}>
						<img
							src={content.image}
							alt={content.name}
							style={{ width: "100%", height: "200px", objectFit: "cover" }}
						/>
						<Box sx={{ position: "absolute", top: 0, right: 4 }}>
							<Icon
								family={creator.favoriteIconType}
								name={creator.favoriteIconName}
								fontSize={"14px"}
							/>
						</Box>
					</Box>
					<Box
						sx={{
							padding: 1,
							paddingTop: 0,
							display: "flex",
							flexDirection: "column",
							justifyContent: "space-between",
							height: "180px",
							mt: 1,
						}}
					>
						<Box>
							<Box
								sx={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<Typography
									variant="body2"
									sx={{ fontSize: "10px", fontWeight: "bold" }}
								>
									{content.name}
								</Typography>
								<Typography
									variant="h6"
									sx={{ fontWeight: "bold", fontSize: "8px" }}
								>
									{content.price}
								</Typography>
							</Box>
							<Typography variant="body1" sx={{ fontSize: "8px" }}>
								<span
									dangerouslySetInnerHTML={{
										__html: content.description.replace(/\n/g, "<br>"),
									}}
								/>
							</Typography>
						</Box>
						<Box>
							{showProductOptions && (
								<Button
									variant="outline"
									fullWidth
									sx={{
										backgroundColor: "#ffffff",
										"&:hover": {
											backgroundColor: "#ffffff",
										},
										color: "#000000",
										fontSize: "7px",
										borderRadius:
											creator && creator.buttonRounded ? "24px" : "0px",
										fontWeight: "bold",
										textTransform: "inherit",
										height: "28px",
										padding: 0,
										border: "1px solid #aaaaaa",
										marginBottom: 1,
										marginTop: 1,
									}}
								>
									{t("productDetails.options")}
									<KeyboardArrowDownIcon
										sx={{ fontSize: 8, color: "#000000" }}
									/>
								</Button>
							)}
							<Button
								variant="contained"
								fullWidth
								sx={{
									backgroundColor: creator ? creator.color : "#45A049",
									"&:hover": {
										backgroundColor: creator ? creator.color : "#45A049",
									},
									color:
										creator && creator.whiteTextButton ? "#ffffff" : "#000000",
									fontSize: "8px",
									borderRadius:
										creator && creator.buttonRounded ? "24px" : "0px",
									fontWeight: "bold",
									textTransform: "uppercase",
									height: "28px",
									width: "100%",
								}}
							>
								{t("productDetails.addToCart")}
							</Button>
						</Box>
					</Box>
				</Box>
			)}
			{product?.value === "productDetail5" && content && (
				<Box sx={{}}>
					<Box
						sx={{
							position: "relative",
							width: "100%",
							height: "200px",
							padding: 1,
						}}
					>
						<img
							src={content.image}
							alt={content.name}
							style={{ width: "100%", height: "200px", objectFit: "cover" }}
						/>
						<Box sx={{ position: "absolute", top: 10, right: 10 }}>
							<Icon
								family={creator.favoriteIconType}
								name={creator.favoriteIconName}
								fontSize={"14px"}
							/>
						</Box>
					</Box>
					<Box
						sx={{
							padding: 1,
							paddingTop: 0,
							display: "flex",
							flexDirection: "column",
							justifyContent: "space-between",
							height: "170px",
							mt: 2,
						}}
					>
						<Box>
							<Box
								sx={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<Typography
									variant="body2"
									sx={{ fontSize: "10px", fontWeight: "bold" }}
								>
									{content.name}
								</Typography>
								<Typography
									variant="h6"
									sx={{ fontWeight: "bold", fontSize: "8px" }}
								>
									{content.price}
								</Typography>
							</Box>
							<Typography variant="body1" sx={{ fontSize: "8px" }}>
								<span
									dangerouslySetInnerHTML={{
										__html: content.description.replace(/\n/g, "<br>"),
									}}
								/>
							</Typography>
						</Box>
						<Box>
							{showProductOptions && (
								<Button
									variant="outline"
									fullWidth
									sx={{
										backgroundColor: "#ffffff",
										"&:hover": {
											backgroundColor: "#ffffff",
										},
										color: "#000000",
										fontSize: "7px",
										borderRadius:
											creator && creator.buttonRounded ? "24px" : "0px",
										fontWeight: "bold",
										textTransform: "inherit",
										height: "28px",
										padding: 0,
										border: "1px solid #aaaaaa",
										marginBottom: 1,
										marginTop: 1,
									}}
								>
									{t("productDetails.options")}
									<KeyboardArrowDownIcon
										sx={{ fontSize: 8, color: "#000000" }}
									/>
								</Button>
							)}
							<Button
								variant="contained"
								fullWidth
								sx={{
									backgroundColor: creator ? creator.color : "#45A049",
									"&:hover": {
										backgroundColor: creator ? creator.color : "#45A049",
									},
									color:
										creator && creator.whiteTextButton ? "#ffffff" : "#000000",
									fontSize: "8px",
									borderRadius:
										creator && creator.buttonRounded ? "24px" : "0px",
									fontWeight: "bold",
									textTransform: "uppercase",
									height: "28px",
									width: "100%",
								}}
							>
								{t("productDetails.addToCart")}
							</Button>
						</Box>
					</Box>
				</Box>
			)}
		</Box>
	);
};

export default ShowcaseProductDetail;
